import React, {useState} from 'react'
import {useIntl} from 'react-intl'
import {Modal} from 'react-bootstrap'
import {Button} from '../form/Button'
import AuthService from '../../../../app/modules/auth/core/_requests'
import useCancelToken from '../../../hooks/UseCancelToken'
import {toast} from 'react-toastify'
import {useAuth} from '../../../../app/modules/auth'
import UserService from '../../../../app/modules/users/core/_requests'
import {toAbsoluteUrl} from '../../../helpers'

type Props = {
  show: boolean
  closeModal: () => void
}
const RequiredVerifyEmail: React.FC<Props> = ({show, closeModal}) => {
  const intl = useIntl()
  const {newCancelToken, isCancel} = useCancelToken()
  const [loading, setLoading] = useState(false)
  const [closing, setClosing] = useState(false)
  const {currentUser, setCurrentUser} = useAuth()

  const resendVerificationEmail = async () => {
    try {
      setLoading(true)
      const config = {cancelToken: newCancelToken()}
      let payload = {
        identifier: currentUser?.email || '',
      }

      const response = await AuthService.resendVerificationEmail(payload, config)
      if (response) {
        toast.success(intl.formatMessage({id: 'ENTER_VERIFICATION_ACCOUNT_SENT'}))
      }
    } catch (error: any) {
      if (isCancel(error)) return
      toast.success(intl.formatMessage({id: 'SEND_VERIFICATION_ACCOUNT_ERROR'}))
    } finally {
      setLoading(false)
    }
  }

  const handleCloseModal = async () => {
    try {
      setClosing(true)
      const config = {cancelToken: newCancelToken()}
      const user = await UserService.getUser(config)
      setCurrentUser(user)

      closeModal()
    } finally {
      setClosing(false)
    }
  }

  return (
    <Modal
      id='gori_order_modal_required_verify_email'
      tabIndex={-1}
      aria-hidden='true'
      centered
      dialogClassName='modal-size-md h-auto'
      contentClassName='modal-padding'
      show={show}
      onHide={handleCloseModal}
      backdrop='static'
      keyboard={false}
    >
      {closing && (
        <div
          className='position-absolute top-0 start-0 w-100 h-100 bg-white bg-opacity-75 d-flex justify-content-center align-items-center rounded'
          style={{zIndex: 1000}}
        >
          <img src={toAbsoluteUrl('/media/gori/orders/reload.gif')} className='w-100px' alt='' />
        </div>
      )}
      <Modal.Header
        closeButton
        className='border-0 justify-content-end modal-header px-15 pt-15 pb-5'
      ></Modal.Header>
      <Modal.Body className='pt-0 pb-15 px-15 modal-body'>
        <div className='fw-bolder fs-1 text-black text-center pb-10'>
          <span>{intl.formatMessage({id: 'VERIFY_YOUR_EMAIL'})}</span>
        </div>
        <div className='bg-light rounded-3 mb-10'>
          <p className='fw-normal fs-5 text-black p-6'>
            {intl.formatMessage({id: 'VERIFY_EMAIL_GUIDE_MESSAGE'})}
          </p>
        </div>
        <div className='w-100'>
          <Button
            id='resend_email_verification'
            className='resend-email-verification d-block w-100 text-white fs-5 fw-500 btn btn-lg rounded px-3 py-4 mx-auto'
            label={intl.formatMessage({id: 'RESEND_EMAIL_VERIFICATION'})}
            loadingText={intl.formatMessage({id: 'RESEND_EMAIL_VERIFICATION'})}
            loading={loading}
            disabled={loading}
            event={resendVerificationEmail}
          />
        </div>
      </Modal.Body>
    </Modal>
  )
}

export {RequiredVerifyEmail}
